import * as React from 'react';
import {useState} from 'react';
import {Form} from "@intelingu/core/components/form/Form";
import {
    SearchAlreadyCreatedCardsDocument,
    SearchAlreadyCreatedCardsQuery,
    SearchAlreadyCreatedCardsQueryVariables,
    useGetVocabularyCardByIdQuery,
    useUpdateCardMutation
} from "../../../../types.d";
import {getParam} from "../../../../utils/getParam";
import {Field} from "@intelingu/core/components/form/Field";
import {FormGroup} from "../../../partials/form/elements/FormGroup";
import {WordMasks, WordMasksController} from "../../../partials/WordMasks";
import {container} from "@intelingu/core/IoC/container";
import {WorkspaceStore} from "../../../../stores/WorkspaceStore";
import {QuotaCheckField} from "../../../partials/QuotaCheckField";
import {Redirect} from "react-router";
import {SubmitButton} from "../../../partials/form/elements/SubmitButton";
import moment from "moment";
import {useAppendToMce} from "./CreateVocabulary";
import {TinyMCE} from "../../../partials/form/elements/TinyMCE";
import {FormStore} from "@intelingu/core/stores/FormStore";
import {RecentTopic} from "../../../partials/RecentTopic";
import {AudioRecorder} from "../../../partials/AudioRecorder";
import {Checkbox} from "../../../partials/form/elements/Checkbox";
import {Observer} from "mobx-react";
import {TextInput} from "../../../partials/form/elements/TextInput";
import {graphql} from "../../../../configs/graphql.client";
import {Link} from "react-router-dom";
import Async from 'react-select/async';
import debounce from "debounce-promise";
import {IsNotEmpty, Validate, ValidateIf} from "class-validator";
import {MceValidator} from "../../../../utils/mceValidator";
import {EscalationEvaluation} from "../../../partials/EscalationEvaluation";
import {FormErrorMessage} from "../../../partials/form/FormErrorMessage";

export class EditValidator {}

export class Validator {

    @Validate(MceValidator)
    exampleSentence;

    @Validate(MceValidator)
    exampleSentenceTranslation;

    @Validate(MceValidator)
    exampleSentenceTranslation2;

    @Validate(MceValidator)
    exampleSentence2;

    @IsNotEmpty()
    infinitivesOnly;

    @IsNotEmpty()
    infinitivesOnly2;

    @IsNotEmpty()
    sentenceAudio;

    @IsNotEmpty()
    sentenceAudio2;

    @IsNotEmpty()
    cardFeedback;

}

export const EscalateVocabularyForm = props => {
    const [created, setCreated] = useState<boolean>(false);
    const [form, setForm] = useState<FormStore>();
    const editMode = !!props.editMode;

    const [masksController, setMasksController] = useState<WordMasksController>();
    const [masksController2, setMasksController2] = useState<WordMasksController>();
    const [editorRef, setEditorRef] = useState<any>();
    const [editorRef2, setEditorRef2] = useState<any>();

    const appendToMce1 = useAppendToMce(editorRef);
    const appendToMce2 = useAppendToMce(editorRef2);

    const courseId = container.get(WorkspaceStore).courseId;

    const [ updateCard, { data: updatedCard } ] = useUpdateCardMutation({
        fetchPolicy: 'no-cache'
    });

    const appendToMce = useAppendToMce(editorRef);

    const {
        data
    } = useGetVocabularyCardByIdQuery({
        fetchPolicy: 'network-only',
        variables: { id: getParam<number>('card_id') }
    });

    if (!data || !data.card) {
        return <h2>Loading...</h2>
    }

    const { card } = data;

    if (created) {
        if (editMode) {
            return <h2>Saved...</h2>
        }

        return <Redirect to={`/creation/next/${courseId}/LP`} />
    }

    const date: string = moment().format("YYYY-MM-DD HH:mm:ss");
    const wordTranslation = card.wordTranslation;
    const rank = wordTranslation.sourceWord.rank;

    return <Form
        validator={editMode ? EditValidator : Validator}
        onReady={data => setForm(data.store)}
        defaultData={{
            reviewedAt: date,
            infinitivesOnly: card.infinitivesOnly,
            infinitivesOnly2: card.infinitivesOnly2,
            exampleSentence: card.exampleSentence,
            exampleSentence2: card.exampleSentence2,
            sentenceAudio: card.sentenceAudio,
            sentenceAudio2: card.sentenceAudio2,
            exampleSentenceTranslation: card.exampleSentenceTranslation,
            exampleSentenceTranslation2: card.exampleSentenceTranslation2,
            info: card.info,
            editingRequiredAt: card.editingRequiredAt,
            editingRequiredComment: card.editingRequiredComment,
            derivableFromWords: card.derivableFromWords,
        }}
        onSubmit={async (data, done) => {
            const value = JSON.parse(JSON.stringify(data));

            await updateCard({
                variables: {
                    id: getParam<number>('card_id'),
                    input: value,
                    editMode
                }
            });

            done();

            setCreated(true);
        }}
    >
        <div className="row px-3">
            <div className="col-4">
                <label><strong>Source Language</strong>:</label>
                <span className="mx-1">{ wordTranslation.sourceLanguage.name }</span>
            </div>
            <div className="col-8">
                <label>
                    <strong>Translation Language</strong>:</label>
                <span className="mx-1">{ wordTranslation.translationLanguage.name }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-4">
                <label><strong>Part Of Speech</strong>:</label>
                <span className="mx-1">{ wordTranslation.sourceWord.posDefinition } ({ wordTranslation.sourceWord.pos })</span>
            </div>
            <div className="col-8">
                <label><strong>Creator</strong>:</label>
                <span className="mx-1">{ card.postAuthorName }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-4">
                <label><strong>Position of Vocabulary</strong>:</label>
                <span className="mx-1">{ wordTranslation.sourceWord.rank }</span>
            </div>
            <div className="col-8">
                <label><strong>Reviewer</strong>:</label>
                <span className="mx-1">{ card.approvingName }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-4">
                <label><strong>Vocabulary</strong>:</label>
                <span className="mx-1">{ wordTranslation.sourceWord.lemma }</span>
            </div>
            <div className="col-8">
                <label><strong>Translation</strong>:</label>
                <span className="mx-1">{ wordTranslation.translationWord.lemma }</span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <label><strong>Translation Audio</strong>:</label>
                <span className="mx-1">
                    <audio controls={true} src={wordTranslation.audio} />
                </span>
            </div>
        </div>

        <div className="row px-3">
            <div className="col-12">
                <Link to={`/lp/translation/?translation_id=${wordTranslation.id}`} className="btn btn-outline-primary ">Revise translation</Link>
            </div>
        </div>

        { (card.editingRequiredComment && card.editingRequiredComment.length) && (
            <div className="row px-3 mt-5">
                <div className="col-12">
                    <label><strong>Comment to Media Editor</strong>:</label>
                    <span className="mx-1">{ card.editingRequiredComment }</span>
                </div>
            </div>
        ) }

        { card.reviewDescription && <div className={'row px-3 mt-5'}>
            <div className="col-12">
                <label><strong>Disapprove comment</strong>:</label>
                <pre className="mx-1 disapprove-comment" dangerouslySetInnerHTML={{ __html: card.reviewDescription }} />
            </div>
        </div> }

        <FormGroup
            className={'mt-5'}
            label={'1st MNEMO-ENHANCER: Relevant (ordinary) usage of vocabulary'}
            required={true}
        >
            <WordMasks
                onReady={setMasksController}
                courseId={container.get(WorkspaceStore).courseId}
                onSelect={appendToMce1}
                rank={rank} />

            <Field
                name={'exampleSentence'}
                render={props => (
                    <TinyMCE
                        toolbar={''}
                        editor={setEditorRef}
                        {...props} />
                )} />
        </FormGroup>

        <FormGroup label={'Sentence audio (record hotkey: Ctrl+1)'} required={true}>
            <Field
                name={'sentenceAudio'}
                render={props => <AudioRecorder waitOptimized {...props} />} />
        </FormGroup>

        <FormGroup label={'Original quota check'}>
            { masksController && (
                <Field name={'infinitivesOnly'} render={props => (
                    <QuotaCheckField
                        includedWords={[wordTranslation.sourceWord.lemma]}
                        isStatic={true}
                        originalMode={true}
                        sourceLanguage={card.course.sourceLanguage.id}
                        translationLanguage={card.course.translationLanguage.id}
                        wordMasksController={masksController}
                        getInfinitives={() => {
                            if (card.infinitivesOnly) {
                                const json = JSON.parse(card.infinitivesOnly);
                                return json.join(' ');
                            }

                            return '';
                        }}
                        {...props} />
                )} />
            ) }

            { card.quotaExplanation1 && (
                <div className={'alert alert-info'}>Quota Explanation: { card.quotaExplanation1 }</div>
            ) }

            { card.counterQuotaExplanation1 && (
                <div className={'alert alert-info'}>Counter Quota Explanation: { card.counterQuotaExplanation1 }</div>
            ) }
        </FormGroup>

        <FormGroup label={'Infinitives Only'}>
            <Field name={'infinitivesOnly'} render={props => (
                <QuotaCheckField
                    includedWords={[wordTranslation.sourceWord.lemma]}
                    escalateMode={true}
                    sourceLanguage={card.course.sourceLanguage.id}
                    translationLanguage={card.course.translationLanguage.id}
                    explanationQuotaFieldName={'quotaExplanation1'}
                    explanationCounterFieldName={'counterQuotaExplanation1'}
                    wordMasksController={masksController}
                    getInfinitives={() => editorRef.editor.getContent({format: 'text'})}
                    {...props} />
            )} />
        </FormGroup>

        <FormGroup label={'TRANSLATION OF 1st MNEMO-ENHANCER'} required={true}>
            <Field
                name={'exampleSentenceTranslation'}
                render={props => <TinyMCE toolbar={''} {...props} />} />
        </FormGroup>

        <div className={'separator'} />

        <FormGroup label={'2nd MNEMO-ENHANCER: Application of recent Grammar Topic'} required={true}>
            <RecentTopic
                translationLanguage={wordTranslation.translationLanguage.id}
                sourceLanguage={wordTranslation.sourceLanguage.id}
                cardId={wordTranslation.id}
                rank={rank} />

            <WordMasks
                onReady={setMasksController2}
                courseId={container.get(WorkspaceStore).courseId}
                onSelect={appendToMce2}
                rank={rank} />

            <Field
                name={'exampleSentence2'}
                render={props => (
                    <TinyMCE
                        toolbar={''}
                        editor={setEditorRef2}
                        {...props} />
                )} />
        </FormGroup>

        <FormGroup label={'Sentence audio (record hotkey: Ctrl+1)'} required={true}>
            <Field
                name={'sentenceAudio2'}
                render={props => <AudioRecorder waitOptimized {...props} />} />
        </FormGroup>

        <FormGroup label={'Original quota check'}>
            { masksController2 && (
                <Field name={'infinitivesOnly2'} render={props => (
                    <QuotaCheckField
                        includedWords={[wordTranslation.sourceWord.lemma]}
                        isStatic={true}
                        originalMode={true}
                        sourceLanguage={card.course.sourceLanguage.id}
                        translationLanguage={card.course.translationLanguage.id}
                        wordMasksController={masksController2}
                        getInfinitives={() => {
                            if (card.infinitivesOnly2) {
                                const json = JSON.parse(card.infinitivesOnly2);
                                return json.join(' ');
                            }

                            return '';
                        }}
                        {...props} />
                )} />
            ) }

            { card.quotaExplanation2 && (
                <div className={'alert alert-info'}>Quota Explanation: { card.quotaExplanation2 }</div>
            ) }

            { card.counterQuotaExplanation2 && (
                <div className={'alert alert-info'}>Counter Quota Explanation: { card.counterQuotaExplanation2 }</div>
            ) }
        </FormGroup>

        <FormGroup label={'Infinitives Only'}>
            <Field name={'infinitivesOnly2'} render={props => (
                <QuotaCheckField
                    includedWords={[wordTranslation.sourceWord.lemma]}
                    escalateMode={true}
                    sourceLanguage={card.course.sourceLanguage.id}
                    translationLanguage={card.course.translationLanguage.id}
                    explanationQuotaFieldName={'quotaExplanation2'}
                    explanationCounterFieldName={'counterQuotaExplanation2'}
                    wordMasksController={masksController2}
                    getInfinitives={() => editorRef2.editor.getContent({format: 'text'})}
                    {...props} />
            )} />
        </FormGroup>

        <FormGroup label={'TRANSLATION OF 2nd MNEMO-ENHANCER'} required={true}>
            <Field
                name={'exampleSentenceTranslation2'}
                render={props => <TinyMCE toolbar={''} {...props} />} />
        </FormGroup>

        <div className={'separator'} />

        <FormGroup label={'Info'}>
            <Field
                name={'info'}
                render={props => <TinyMCE toolbar={'bold | audio | preview'} {...props} />} />
        </FormGroup>

        <FormGroup>
            <Field
                name={'editingRequiredAt'}
                render={props => <Checkbox {...props} label={'Editing required'} />} />
        </FormGroup>

        <Observer>
            { () => form?.data.editingRequiredAt ? (
                <FormGroup label={'Comment'}>
                    <Field
                        name={'editingRequiredComment'}
                        render={props => <TextInput {...props} />} />
                </FormGroup>
            ) : null }
        </Observer>

        <FormGroup label={'DERIVABLE from words, already learned?'}>
            <Field
                name={'derivableFromWords'}
                render={props => <TinyMCE toolbar={'bold | audio | preview'} {...props} />} />
        </FormGroup>

        <FormGroup label={'Search here for words, already added before'}>
            <Async
                loadOptions={debounce(async (query) => {
                    const result = await graphql.client.query<SearchAlreadyCreatedCardsQuery, SearchAlreadyCreatedCardsQueryVariables>({
                        query: SearchAlreadyCreatedCardsDocument,
                        variables: {
                            query,
                            sourceLanguage: wordTranslation.sourceLanguage.id,
                            translationLanguage: wordTranslation.translationLanguage.id,
                        }
                    });

                    return result.data.searchAlreadyCreatedCards.map(result => ({
                        label: result.text,
                        value: result.id
                    }));
                }, 300)}
                options={[]} />
        </FormGroup>

        { !editMode && (
            <FormGroup>
                <Field name={'cardFeedback'} render={props => {
                    return <EscalationEvaluation
                        onChange={value => props.onChange(value)}
                    />
                }} />
            </FormGroup>
        ) }

        <div className={'col-12'}>
            <FormErrorMessage />
            <Field submit render={props => <SubmitButton {...props}>Done</SubmitButton>} />
        </div>
    </Form>
};

export const EscalateVocabulary = props => (
    <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <div className="ig-form-heading">
                <h1 className="form-primary-title">{
                    props.editMode ? 'VOCABULARY CARD: EDIT' : 'VOCABULARY CARD: FINAL DECISION NEEDED'
                }</h1>
            </div>

            <EscalateVocabularyForm editMode={props.editMode} />
        </div>
    </div>
);
